import React from 'react'
import PropTypes from 'prop-types'
import withStyles from '@material-ui/core/styles/withStyles'
import Divider from '@material-ui/core/Divider/Divider'
import {Menu} from './components/molecules/Menu'
import Breadcrumbs from './shared/components/Breadcrumbs'
import Header from './components/molecules/Header/Header'
import {CSSTransition, TransitionGroup} from 'react-transition-group'
import PageProgress from './shared/components/PageProgress'
import EnvBar from './shared/components/atoms/EnvBar'
import Colors from './shared/assets/styles/colors'
import {LanguageProvider} from './LanguageContext'

const styles = ({spacing: {unit}}) => ({
  '@media print': {
    content: {
      backgroundColor: Colors.White
    }
  },
  root: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    height: '100vh',
    background:
      'linear-gradient(145deg, ' +
      'rgba(207,174,168,0.3) 16%, ' +
      'rgba(139,188,188,0.3) 45%, ' +
      'rgba(100,193,195,0.3) 60%, ' +
      'rgba(73,184,161,0.3) 80%, ' +
      'rgba(80,178,104,0.3) 98%)'
  },
  content: {
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
    width: '100%'
  },
  loader: {
    position: 'absolute',
    width: '100%',
    zIndex: 9999
  },
  breadcrumbs: {
    minHeight: unit * 4
  },
  page: {
    padding: unit,
    paddingBottom: unit * 4,
    overflow: 'scroll',
    height: '100%'
  },
  fadeEnter: {
    opacity: 0,
    transform: `translate3d(0, ${-unit * 2}px, 0)`
  },
  fadeEnterActive: {
    opacity: 1,
    transform: 'translate3d(0,0,0)',
    transition: `opacity 350ms 100ms,
       transform 350ms ease-out 100ms
      `
  }
})

class AppFrame extends React.Component {
  constructor(props) {
    super(props)

    const cookies = document.cookie.split(/;\s?/).reduce((data, pair) => {
      const [key, value] = pair.split('=')
      return {...data, [key]: value}
    }, {})

    this.state = {
      language: (cookies.language || navigator.language || '')
        .toLowerCase()
        .substr(0, 2),
      languageSwitchInterceptors: []
    }

    this.languageSwitchInterceptors = []
  }

  handleLanguageChange = selectedLanguage => {
    if (
      this.languageSwitchInterceptors.some(interceptor =>
        interceptor(selectedLanguage)
      )
    )
      return

    document.cookie = `language=${selectedLanguage.id};path=/`
    this.setState({selectedLanguage})
  }

  onRegisterLanguageSwitchInterceptor = interceptor => {
    this.languageSwitchInterceptors.push(interceptor)

    return () => {
      const i = this.languageSwitchInterceptors.indexOf(interceptor)
      if (i >= 0) this.languageSwitchInterceptors.splice(i, 1)
    }
  }

  render() {
    const {
      classes,
      member,
      api,
      busy,
      children,
      data: {
        settings: {languages: supportedLanguages = []} = {},
        menu,
        header,
        env: {color} = {}
      } = {},
      routeKey,
      contentKey
    } = this.props

    let {selectedLanguage, language} = this.state
    if (!selectedLanguage && supportedLanguages.length > 0) {
      selectedLanguage =
        supportedLanguages.find(({id}) => id === language) ||
        supportedLanguages[0]
    }

    return (
      <div className={classes.root}>
        {color && <EnvBar color={color} />}

        <LanguageProvider
          value={{
            supportedLanguages,
            selectedLanguage,
            registerLanguageSwitchInterceptor: this
              .onRegisterLanguageSwitchInterceptor,
            onLanguageChange: this.handleLanguageChange
          }}
        >
          {header && <Header data={header} member={member} api={api} />}

          <div style={{display: 'flex', height: '100%'}}>
            {menu && <Menu menu={menu} children={this.props.children} />}
            <main className={classes.content}>
              {menu && (
                <React.Fragment>
                  <Breadcrumbs className={classes.breadcrumbs} menu={menu} />
                  <Divider />
                </React.Fragment>
              )}
              <TransitionGroup className={classes.page}>
                <CSSTransition
                  key={routeKey}
                  timeout={{enter: 1000, exit: 0}}
                  classNames={{
                    enter: classes.fadeEnter,
                    enterActive: classes.fadeEnterActive
                  }}
                >
                  <div key={contentKey}>{children}</div>
                </CSSTransition>
              </TransitionGroup>
            </main>
          </div>

          <PageProgress visible={busy} className={classes.loader} />
        </LanguageProvider>
      </div>
    )
  }
}

AppFrame.propTypes = {
  classes: PropTypes.object.isRequired
}

export default withStyles(styles)(AppFrame)



// WEBPACK FOOTER //
// ./src/AppFrame.js